import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddServiceType = ({ show, onClose, refresh }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [servicetype_name, setname] = useState('');
    const [description, setdescription] = useState('');
    const [errors, setErrors] = useState({});
    const [data_name, setData] = useState([]);

    useEffect(() => {
        axios.get(`${baseURL}/servicetype`)
          .then(response => {
            setData(response.data.data.map(mode => mode.servicetype_name.toLowerCase()));
          })
          .catch(error => {
            console.log('There was an error fetching the data!', error);
          });
    }, []);
    
    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    const validate = () => {
        const newErrors = {};
        const regex = /^[A-Za-z\s]+$/;

        if (!servicetype_name.trim()) {
            newErrors.name = "This Field is Required.";
            // return newErrors;
        } else if (!regex.test(servicetype_name)) {
            newErrors.name = "Not a Valid Name";
            // return newErrors;
        } else if (data_name.includes(servicetype_name.trim().toLowerCase())) {
            newErrors.name = "This Name Alredy Exists";
            // return newErrors;
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = { servicetype_name, description };
        axios.post(`${baseURL}/servicetype`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Service Type Created Successfully");
                // window.location.reload();
            })
            .catch(error => {
                console.log(error);
                toast.error("Service Type Creation Failed");
            });
    };

    return (
        <Modal show={show}  size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Service Type</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Service Type<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Service Type" 
                                    maxLength={100}
                                    value={servicetype_name} 
                                    onChange={(e) => setname(formatName(e.target.value))} 
                                />
                                {errors.name && <div className="text-danger fs-8 mt-1">{errors.name}</div>}
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Description</label>
                                <textarea rows={8} className="form-control" name="comment" placeholder="Description"
                                    defaultValue={""}
                                    maxLength={255}
                                    value={description} 
                                    onChange={(e) => setdescription(formatName(e.target.value))}
                                />
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                            {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                            <button type="submit" className="btn btn-sm btn-primary" >Create Service Type<i className="fas fa-angle-double-right ms-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default AddServiceType;
